import { createSlice } from '@reduxjs/toolkit';
import {
  fetchWorkflowSteps,
  updateWorkflowSteps,
} from './actions';

const initialState = {
  workflowSteps: null,
  workflowStepsLoading: false,
  workflowStepsSaving: false,
  error: null,
};

const workflowSlice = createSlice({
  name: 'workflow',
  initialState,
  reducers: {
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchWorkflowSteps.pending, (state) => {
        state.workflowStepsLoading = true;
        state.error = null;
        state.workflowSteps = null;
      })
      .addCase(fetchWorkflowSteps.fulfilled, (state, action) => {
        state.workflowStepsLoading = false;
        state.workflowSteps = action.payload?.data ?? action.payload;
      })
      .addCase(fetchWorkflowSteps.rejected, (state, action) => {
        if (action.meta.aborted) return;
        state.workflowStepsLoading = false;
        state.error = action.payload?.message ?? action.error?.message ?? 'Failed to fetch workflow steps';
      })

      .addCase(updateWorkflowSteps.pending, (state) => {
        state.workflowStepsSaving = true;
        state.error = null;
      })
      .addCase(updateWorkflowSteps.fulfilled, (state, action) => {
        state.workflowStepsSaving = false;
        state.workflowSteps = action.payload?.data ?? action.payload;
      })
      .addCase(updateWorkflowSteps.rejected, (state, action) => {
        state.workflowStepsSaving = false;
        state.error = action.payload?.message ?? action.error?.message ?? 'Failed to update workflow steps';
      });
  },
});

export default workflowSlice.reducer;
